import React from 'react'

const NoFulfilmentTimeTypesAvailable = ({ classes }) => (
  <span className={classes.noTimes}>Currently Closed</span>
)

export default NoFulfilmentTimeTypesAvailable
